import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import Iframe from 'react-iframe'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// import DateTimePicker from 'react-datetime-picker';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as actions from '../../store/actions/index';
import Button from '@material-ui/core/Button';
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const styles = theme => ({
    textColor:{
        color: '#a52423'
    },
    divStyle:{
        // height:'700px',
    },
    divStyle2:{
        width:'100%',
        alignItems:'center',
    },
    padding:{
        padding:'10px'
    },
    subText:{
        color: '#a52423',
        paddingLeft:'30px'
    },
    paper:{
        align:'center',
        textAlign: 'center',
        marginTop: '1vh',
        color:'#a52423'
    },
});

class TeleConferencing extends Component {
    constructor(props){
        super(props);
    }
    state = {
        numPages: null,
        pageNumber: 1,
        date: new Date(),
        typeOfAccount: localStorage.getItem('typeOfAccount'),
        uniqueId:localStorage.getItem('token'),
        userShow:false,
        scheduledtime: '',

    }

    onChange = date => {
        console.log('onChange date: '+date)
        this.setState({ date })
    }

    scheduleMeeting_ = (audioOnly) => {
        console.log('(this.state.date).toLocaleString(): '+(this.state.date))
         this.props.scheduleMeeting(this.props.caseId, (this.state.date).toLocaleString(), this.state.date, audioOnly)
    }

    removeScheduleMeeting_ = () => {
        console.log('called removeScheduleMeeting_')
        this.props.removeScheduleMeeting(this.props.caseId)
   }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    componentWillUpdate(){

    }

    componentDidMount(){
        setInterval(()=>{
            if (this.props.caseData.teleconferencing !== undefined){
                if (this.props.caseData.teleconferencingDateTime !== undefined){
                    var dateTime = new Date(this.props.caseData.teleconferencingDateTime);
                    var scheduledtime = (''+this.props.caseData.teleconferencingDateTimeForShow).replace('T',' ').replace('Z','')
                    this.setState({
                        scheduledtime:scheduledtime
                    })
                    var now = new Date();

                    var diffMs = (dateTime - now); // milliseconds between now & meeting
                    var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
                    console.log(diffMins + " minutes until meeting");

                    let userType = '';
                    if(this.props.claimantUniqueId == this.state.uniqueId){
                        userType = 'Claimant';
                    }else if(this.props.respondentUniqueId == this.state.uniqueId){
                        userType = 'Respondent';
                    }
                    else{
                        userType = 'Host'
                    }
                    console.log('(diffMins > -40): '+(diffMins > -40))
                    if (diffMins > -40){
                        if (this.state.typeOfAccount == 'admin' || this.state.typeOfAccount == 'arbitrator'){
                            localStorage.setItem("mrole",1)
                        }
                        else{
                            localStorage.setItem("mrole",0)
                        }
                        localStorage.setItem('display_name', userType)
                        localStorage.setItem('mnumber', this.props.caseData.zoomDetails.id)
                        localStorage.setItem('mpwd', this.props.caseData.zoomDetails.password)
                        localStorage.setItem('memail', this.props.caseData.zoomDetails.host_email)
                        localStorage.setItem('zoomLink', this.props.caseData.zoomDetails.join_url)
                        console.log('setting display_name: '+userType+' mnumber: '+this.props.caseData.zoomDetails.id+ ' mpwd: '+this.props.caseData.zoomDetails.password+' memail: '+this.props.caseData.zoomDetails.host_email)
                        this.setState({ userShow: true });
                    }
                    else{
                        if (!isNaN(diffMins) ){
                            this.removeScheduleMeeting_();
                        }
                    }


                }
            }
        },2000)
    }

    render(){
        
        const { classes, file, mobile } = this.props;
        let { numPages, pageNumber } = this.state;
        let fileURL = ``;
        if (mobile){
            fileURL = `${process.env.REACT_APP_SERVER_HOSTNAME}/odr/Local/indexMobile.html`;
        }
        else{
            fileURL = `${process.env.REACT_APP_SERVER_HOSTNAME}/odr/Local/index.html`;
        }
        
        console.log('teleconf fileUrl: '+fileURL)
        
        if (this.state.typeOfAccount == 'admin' || this.state.typeOfAccount == 'arbitrator'){
            if (this.props.caseData.teleconferencing !== undefined){
                if (this.props.caseData.teleconferencing == true){
                        return (
                            <div className={classes.divStyle}>
                                <h4 className={classes.paper}> {this.context.t('Hearing is scheduled on: '+this.state.scheduledtime)} </h4>
                            
                                    <div className={classes.divStyle2}>
                                    {this.context.t('Choose Date/Time')}:
                                    <DatePicker
                                        selected={this.state.date}
                                        style="height:300px; width:400px; fontSize:18px;"
                                        onChange={this.onChange}
                                        timeInputLabel=""
                                        dateFormat="MM/dd/yyyy h:mm aa"
                                        showTimeInput
                                    />
                                    <br></br>
                                    <Button 
                                        color="primary" 
                                        aria-label="Add" 
                                        size='medium' 
                                        style={{textTransform:'none'}}
                                        className={classes.formControl} 
                                        onClick={this.scheduleMeeting_.bind(this, false) }>
                                        {this.context.t('Schedule Meeting with Video')}
                                    </Button>
                                    
                                    <Button 
                                        color="primary" 
                                        aria-label="Add" 
                                        size='medium' 
                                        style={{textTransform:'none'}}
                                        className={classes.formControl} 
                                        onClick={ this.scheduleMeeting_.bind(this, true) }>
                                        {this.context.t('Schedule Meeting Audio Only')}
                                    </Button>
                                    <br></br>
                                    </div>
                                    <div>
                                        <Iframe
                                            url={fileURL}
                                            id="myId"
                                            height="100vh"
                                            className="myClassname"
                                            position="relative"
                                        />
                                    </div>
                                </div>
                            );
                }
                else{
                    return (
                        <div className={classes.divStyle}>
                            <div className={classes.divStyle2}>
                            <DatePicker
                                selected={this.state.date}
                                style="height:300px; width:400px; fontSize:18px;"
                                onChange={this.onChange}
                                timeInputLabel=""
                                dateFormat="MM/dd/yyyy h:mm aa"
                                showTimeInput
                            />
                            <br></br>
                            <Button 
                                color="primary" 
                                aria-label="Add" 
                                size='medium' 
                                style={{textTransform:'none'}}
                                className={classes.formControl} 
                                onClick={this.scheduleMeeting_.bind(this, false)}>
                                {this.context.t('Schedule Meeting with Video')}
                            </Button>
                            <br></br>
                            <Button 
                                color="primary" 
                                aria-label="Add" 
                                size='medium' 
                                style={{textTransform:'none'}}
                                className={classes.formControl} 
                                onClick={this.scheduleMeeting_.bind(this, true)}>
                                {this.context.t('Schedule Meeting Audio Only')}
                            </Button>
                            <br></br>
                            </div>
                            {/* <div>
                                <Iframe
                                    url={fileURL}
                                    width="100%"
                                    height="100%"
                                    id="myId"
                                    className="myClassname"
                                    position="absolute"
                                />
                            </div> */}
                        </div>
                    );
                }    
            }
            else{
                return (
                    <div className={classes.divStyle}>
                        <div className={classes.divStyle2}>
                        <DatePicker
                            selected={this.state.date}
                            style="height:300px; width:400px; fontSize:18px;"
                            onChange={this.onChange}
                            timeInputLabel=""
                            dateFormat="MM/dd/yyyy h:mm aa"
                            showTimeInput
                        />
                        <br></br>
                        <Button 
                            color="primary" 
                            aria-label="Add" 
                            size='medium' 
                            style={{textTransform:'none'}}
                            className={classes.formControl} 
                            onClick={this.scheduleMeeting_.bind(this, false)}>
                            {this.context.t('Schedule Meeting with Video')}
                        </Button>
                        <br></br>
                        <Button 
                            color="primary" 
                            aria-label="Add" 
                            size='medium' 
                            style={{textTransform:'none'}}
                            className={classes.formControl} 
                            onClick={this.scheduleMeeting_.bind(this, true)}>
                            {this.context.t('Schedule Meeting Audio Only')}
                        </Button>
                        <br></br>
                        </div>
                        {/* <div>
                            <Iframe
                                url={fileURL}
                                width="100%"
                                height="100%"
                                id="myId"
                                className="myClassname"
                                position="absolute"
                            />
                        </div> */}
                    </div>
                );
            }
        }
        else if (this.state.typeOfAccount == 'user' && this.state.userShow){
            return (
                <div className={classes.divStyle}>
                    <Iframe
                        url={fileURL}
                        id="myId"
                        height="100vh"
                        className="myClassname"
                        position="relative"
                    />
                </div>
            );
        }
        else if (this.props.caseData.teleconferencing !== undefined){
            if (this.props.caseData.teleconferencing == true){
                return (
                    <div className={classes.divStyle}>
                        <h4 className={classes.paper}> {this.context.t('Hearing is scheduled on: '+this.state.scheduledtime)} </h4>
                    </div>
                    );
            }
            else{
                return (
                    <div className={classes.divStyle}>
                        <h4 className={classes.paper}> {this.context.t('Hearing not scheduled or meeting time not yet arrive')} </h4>
                    </div>
                    );
            }
            
        }
        else{
            return (
                <div className={classes.divStyle}>
                    <h4 className={classes.paper}> {this.context.t('Hearing not scheduled or meeting time not yet arrive')} </h4>
                </div>
                );
        }

        
    }

}

const mapStateToProps = (state) => {
    return {
        isLoading: state.uploadDocs.loading,
        files: state.uploadDocs.files,
        userType: state.caseInfo.userType,
        caseId: state.caseInfo.caseId,
        caseData: state.caseInfo.caseData,
        scheduleMeetingFail: state.caseInfo.scheduleMeetingFail,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        scheduleMeeting: (caseId, dateTimeForShow, dateTime, audioOnly) => dispatch(actions.scheduleMeeting(caseId, dateTimeForShow, dateTime, audioOnly)),
        removeScheduleMeeting: (caseId) => dispatch(actions.removeScheduleMeeting(caseId)),
    }
}

TeleConferencing.contextTypes = {
    t: PropTypes.func
}


// export default withStyles(styles)(withRouter(TeleConferencing));
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(TeleConferencing)));